<template>


      <div class="w-full max-w-2xl mx-auto mt-8 sm:mt-12 px-8 pb-24">



        <div>

          <h2 class="text-3xl sm:text-4xl sm:leading-snug font-bold mb-4">You have been invited to fill out a Customer Questionnaire.</h2>
          <p class="text-2xl leading-snug">Please enter the email address and access code you received from Ricoh Consulting Services.</p>

        </div>
        <form @submit.prevent="submitLogin" id="questions-panel">

          <section>


            <div class="bg-gray-100 p-8 rounded shadow my-8 sm:my-12">
              <div class="question pb-4 border-b">

                <input type="text" name="ueml" v-model="ueml" placeholder="Your Email" />
              </div>
              <div class="question pt-4">

                <input type="text" name="ucode" v-model="ucode" placeholder="Access Code"/>
              </div>

            </div>
          </section>

          <section class="mt-4">
            <p v-if="error" class="text-red-500 pb-2 text-center text-xl font-bold">{{ error }}</p>
            <input class="button button-blue w-full text-2xl uppercase font-bold" type="submit" name="submit" value="Begin Questionnaire">
          </section>
        </form>
      </div>

</template>

<script>

// Every failure the user can hit needs a message that tells them what to do next.
// Keys match the `code` field returned by /api/getRecord.
const MESSAGES = {
  MISSING_FIELDS: "Please fill in the email and access code sent to you.",
  INVALID_CREDENTIALS: "That email and access code don't match. Please check both against your invitation email — the access code is case-sensitive.",
  INVALID_LINK: "This questionnaire link isn't valid or has been removed. Please open the full link from your invitation email, or contact your Ricoh representative.",
  RECORD_MALFORMED: "This questionnaire isn't set up correctly. Please contact your Ricoh representative.",
  SERVER_ERROR: "Something went wrong on our end. Please try again in a moment, or contact your Ricoh representative.",
  NETWORK: "We couldn't reach the server. Please check your internet connection and try again."
}

export default {
  name: "login",
  props: {},
  data: function () {
    return {
      ueml: undefined,
      ucode: undefined,
      error: "",
      q: undefined
    }
  },
  methods: {
    submitLogin: async function(){

      this.error = "";

      const recId = this.$route.params.recid;

      if(!recId){
        this.error = MESSAGES.INVALID_LINK;
        return;
      }

      // Codes and emails get copied out of an invitation email, so strip the
      // whitespace that comes with them before it turns into a failed match.
      const ueml = (this.ueml || "").trim().toLowerCase();
      const ucode = (this.ucode || "").trim();

      this.ueml = ueml;
      this.ucode = ucode;

      if(!ueml || !ucode){
        this.error = MESSAGES.MISSING_FIELDS;
        return;
      }

      const url = "/api/getRecord"
      const options = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        body: JSON.stringify(
            {
              ucode: ucode,
              ueml: ueml,
              recId: recId
            }
        )
      }

      console.log("authorizing");

      let response;

      try {
        response = await fetch(url, options);
      } catch (error) {
        console.error("network error", error);
        this.error = MESSAGES.NETWORK;
        return;
      }

      // A crashed or timed-out function returns an HTML error page, not JSON.
      let data;

      try {
        data = await response.json();
      } catch (error) {
        console.error("unreadable response", response.status, error);
        this.error = MESSAGES.SERVER_ERROR;
        return;
      }

      console.log("response", data);

      if(!response.ok || !data || data.error){
        const code = (data && data.code) || (response.status === 401 ? "INVALID_CREDENTIALS" : "SERVER_ERROR");
        console.error("login failed", response.status, code, data);
        this.error = MESSAGES[code] || MESSAGES.SERVER_ERROR;
        return;
      }

      if(!data.data){
        console.error("record has no questionnaire payload", data);
        this.error = MESSAGES.RECORD_MALFORMED;
        return;
      }

      this.prepareQuestionnaire(data.data);
    },
    prepareQuestionnaire: function(doc){
      console.log("prepare", doc);

      if(doc && doc.interview && doc.documentType === 'Production Workflow Questionnaire'){
        if(!doc.interview.V1000){
          doc.interview.V1000 = { final: "" }
          doc.interview.V1001 = { final: 0 }
          doc.interview.V1002 = { Current: 0 }
          doc.interview.V1004 = { Current: 0 }
          doc.interview.V1005 = { Current: 0 }
          doc.interview.V1006 = { Current: 0 }
          doc.interview.V1010 = { Current: 0 }
          doc.interview.V1011 = { Current: 0 }
        }
      }

      this.$store.state.q = doc;
    }
  },
  computed: {}
}
</script>

<style scoped>


.login {

}

</style>
